import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type { IInviteMemberBody, IInviteMemberResponseData } from 'api/dist/routes/organization/[organization_id]/members/invite.js'
import { GetMembersQuery } from '@/api/organization/members/get-members-query'

interface IInviteMemberArgs {
    organizationId: string
    body: IInviteMemberBody
}

export class InviteMemberMutation {
    static async call(api: IApi, args: IInviteMemberArgs) {
        return api
            .post<IInviteMemberResponseData, IInviteMemberBody>(
                `/organization/${args.organizationId}/members/invite`,
                args.body
            )
            .then((res) => res.data)
    }
}

export function useInviteMemberMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<IInviteMemberResponseData, IInviteMemberBody>({
        mutationFn: (body) =>
            InviteMemberMutation.call(api, {
                organizationId: apiParams.organizationId,
                body,
            }),
        onSuccess: () => {
            qc.invalidateQueries({
                queryKey: GetMembersQuery.getKey({ organizationId: apiParams.organizationId }),
            })
        },
    })
}
